import * as React from "react";
import type { SVGProps } from "react";
const SvgIcLevelIndicatorStroke = (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={0.4} y={0.4} width={23.2} height={3.2} rx={1.6} stroke="currentColor" strokeOpacity={0.2} strokeWidth={0.8} /></svg>;
export default SvgIcLevelIndicatorStroke;